import React from 'react';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet, View } from 'react-native';
import { DRNUtil } from '@traveloka/district-util';
import { getBadgeStyle } from './variants';
import { BMPrimitives, useBMTheme } from '../../theme';
import { BMText } from '../..';
import { useBMBadgeCornerRibbonProvider } from '../BadgeCornerRibbon/context';
import { getBorderRadiusWithRibbonAdjusted } from '../BadgeCornerRibbon/variants';
const BMBadgeTag = ({ type, LeadingIcon, maxWidth, label, isDesktop, testID }) => {
    const { BMComponents } = useBMTheme();
    const badgeStyle = getBadgeStyle(type, BMComponents);
    // this provider is used so we don't expose position props to the badge tag
    const { position: cornerRibbonPosition } = useBMBadgeCornerRibbonProvider();
    const Badge = (<View style={[
            styles.container,
            badgeStyle,
            maxWidth ? { maxWidth } : {},
            {
                paddingVertical: LeadingIcon ? 2 : BMComponents.BMUiBadgeVMargin,
                paddingHorizontal: BMComponents.BMUiBadgeVMargin,
                borderRadius: BMComponents.BMUiBadgeRadius,
            },
            getBorderRadiusWithRibbonAdjusted(cornerRibbonPosition),
        ]} testID={testID}>
      {LeadingIcon && (<LeadingIcon accentColor={badgeStyle.color} width={BMPrimitives.BMSize.lg} height={BMPrimitives.BMSize.lg} style={{ marginRight: BMComponents.BMUiBadgeVMargin }}/>)}
      <BMText numberOfLines={1} style={[
            { color: badgeStyle.color },
            DRNUtil.isWeb() && isDesktop ? BMPrimitives.BMTypography.uiLarge : BMPrimitives.BMTypography.uiSmall,
            styles.badgeText,
        ]}>
        {label}
      </BMText>
    </View>);
    return type === 'NEW' ? (<LinearGradient colors={[BMPrimitives.BMBrand.primary, BMPrimitives.BMBrand.primary, '#7DCC00', '#7DCC00']} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} locations={[0, 0.238, 0.7526, 1]} style={[styles.gradient, { borderRadius: BMComponents.BMUiBadgeRadius }]}>
      {Badge}
    </LinearGradient>) : (Badge);
};
const styles = StyleSheet.create({
    gradient: {
        padding: 1,
        alignSelf: 'flex-start',
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'flex-start',
    },
    badgeText: {
        fontWeight: '600',
    },
});
export default BMBadgeTag;
